import { ViewController } from 'elc-service';
import { ForgotPasswordLinkUseCase } from '../use-cases/ForgotPasswordLinkUseCase';
import { SignInUseCase } from '../use-cases/SignInUseCase';
import { AuthFailedUseCase } from '../use-cases/AuthFailedUseCase';
import { action, computed } from 'mobx';
import { SignInRepository } from '../repositories/SignInRepository';
import { IFormStore } from '../domain/entities/IFormStore';
import { ISignInFormValues } from '../domain/entities/ISignInFormValues';
import { createSignInFormStore } from '../domain/entities/SignInFormStoreFactory';

export interface ISignInFormViewControllerConfig {
    signInRepository: SignInRepository;
}

export class SignInFormViewController extends ViewController {
    private signInRepository: SignInRepository;
    private formStore: IFormStore<ISignInFormValues>;

    constructor(config: ISignInFormViewControllerConfig) {
        super();

        this.signInRepository = config.signInRepository;
    }

    @action
    public loaded = async () => {
        this.isLoading = true;

        this.formStore = await createSignInFormStore();
        this.formStore.values.email = this.signInRepository.email;
        this.formStore.values.password = this.signInRepository.password;

        this.isLoading = false;
    };

    @action
    public onForgotPasswordLinkClick = () => {
        const useCase = new ForgotPasswordLinkUseCase();
        useCase.execute();
    };

    @action
    public onSignIn = () => {
        if (!this.formStore) {
            return;
        }

        const { email, password } = this.formStore.values;

        this.signInRepository.setEmail(email);
        this.signInRepository.setPassword(password);

        const useCase = new SignInUseCase();
        void useCase.execute();
    };

    @action
    public onAuthFailed = (error: string) => {
        const useCase = new AuthFailedUseCase(error);
        useCase.execute();
    };

    @computed
    public get data() {
        return {
            formStore: this.formStore,
            apiError: this.signInRepository.apiError,
            isSignInFormValid: this.isValid,
            isSignInInProgress: this.signInRepository.isSignInInProgress,
            isUserWarned: this.signInRepository.isUserWarned
        };
    }

    @computed
    public get isValid() {
        return this.formStore ? this.formStore.isValid : false;
    }
}
